import { Icon } from "../icon"
import { Text } from "../text"
import { viewPresets, textPresets } from "./tag.presets"
import { TagProps } from "./tag.props"
import { Box } from "@mui/material"
import { spacing } from "deprecated-theme"
import { mergeAll, flatten } from "rambdax"
import * as React from "react"

const BASE_TEXT = (icon: string): React.CSSProperties => ({
  paddingRight: Boolean(icon) ? spacing[1] : spacing[0],
})

/**
 * Add a Text Based Tag with an optional icon
 */
export function Tag(props: TagProps) {
  const {
    tx,
    txOptions = {},
    text,
    preset = "default",
    icon,
    style: styleOverride,
    textStyle: textStyleOverride,
    leftView,
  } = props

  const viewStyle = mergeAll(flatten([viewPresets[preset] || viewPresets.default, styleOverride]))

  const textStyle = mergeAll(
    // @ts-ignore
    flatten([BASE_TEXT(icon), textPresets[preset] || textPresets.default, textStyleOverride]),
  )

  return (
    <Box
      // @ts-ignore
      style={viewStyle}>
      {Boolean(icon) ? <Icon icon={icon} /> : null}
      {Boolean(leftView) && leftView}
      {Boolean(text) || Boolean(tx) ? (
        <Text
          // @ts-ignore
          style={textStyle}
          text={text}
          tx={tx}
          txOptions={txOptions}
        />
      ) : null}
    </Box>
  )
}
